<mat-card>
	<mat-card-header>
		<mat-card-title>
			{{data.fromState.NAME}} => {{data.toState.NAME}}
			<button class="close-button" mat-mini-fab [mat-dialog-close]="true">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
		<mat-card-subtitle>
			{{data.role.NAME}}
		</mat-card-subtitle>
	</mat-card-header>

	<mat-card-content>

		<div>
			<h4>Workflow Properties</h4>
			<div *ngFor="let transitionPropertyType of data.role.transitionPropertyTypes" class="margin-vertical-sm">
				<mat-checkbox [disabled]="!hasPermission" [(ngModel)]="transitionPropertyType.hasPropertyType"
					color="primary" (change)="toggleTransitionPropertyType($event, transitionPropertyType)">
				</mat-checkbox>
				{{transitionPropertyType.TYPE}}
			</div>
		</div>
	</mat-card-content>
</mat-card>